import gql from "graphql-tag";
import PropTypes from "prop-types";

export default {
  mutation: gql`
    mutation deleteCardLimit($cardId: ID!, $limitId: ID!) {
      deleteCardLimit(cardId: $cardId, limitId: $limitId) {
        success
      }
    }
  `,
  config: {
    options: ({ cardId, limitId }) => ({
      variables: {
        cardId,
        limitId,
      },
    }),
  },
  propTypes: {
    cardId: PropTypes.string.isRequired,
    limitId: PropTypes.string.isRequired,
  },
};



// WEBPACK FOOTER //
// ./src/model/gql/mutations/cards/cardLimit/deleteCardLimit.js